import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { SiteSurveyAction, RayCodeAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { Translate as t } from '../../config/Translate';
import { DeviceModels } from '../../config';

const SurveyStep1 = ({ Update, info, isSummary = false, gostep, clist }) => {
	const [errors, setErrors] = useState([]);
	const [isAddProcess, setIsAddProcess] = useState(false);
	const numericDefaults = {
		additionalMainUnit: 0, additionalPortableXray: 0, additionalThreedPrinter: 0, additionalCurningUnit: 0,
		additionalRioSensorSize1: 0, additionalRioSensorSize2: 0, additionalRioScanStandard: 0, additionalRioScanOcctusal: 0,
		additionalCb500: 0, additionalCb1l: 0, additionalSg500: 0, additionalSg1l: 0, additionalDb500: 0, additionalDb1l: 0,
		environmentUnitChairs: 0, environmentClientPc: 0, environmentWalmountXray: 0, environmentPotableXray: 0,
	};
	const [siteSurvey, setSiteSurvey] = useState({ ...numericDefaults, ...info, siteSurveyStep: 3 });
	const [category, setCategory] = useState("info");
	const [allModelOptionList, setAllModelOptionList] = useState([]);
	const [options, setOptions] = useState([]);

	useEffect(() => {
		if (gostep) {
			if (gostep.curStep == 2) {
				let errValidate = [];
				const errValidate1 = RayFormValidation(form_controls1, siteSurvey);
				const errValidate2 = RayFormValidation(form_controls2, siteSurvey);
				const errValidate3 = RayFormValidation(form_controls3, siteSurvey);
				errValidate = errValidate.concat(errValidate1);
				errValidate = errValidate.concat(errValidate2);
				errValidate = errValidate.concat(errValidate3);
				if (errValidate.length > 0) {
					setErrors(errValidate);
				} else {
					setIsAddProcess(true);
					Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: gostep.goStepNo });
				}
			}
		}
	}, [gostep])

	useEffect(() => {
		const isMg = JSON.parse(localStorage.getItem("user"))?.isMegagen;
		if (!isMg) {
			setOptionList(siteSurvey.model || "RAYSCAN α+ (NEW)");
		} else {
			setOptionList('R2 Studio Q');
		}
	}, [allModelOptionList])

	const setOptionList = (model) => {
		const list = [];
		allModelOptionList.filter(x => x.group == model).map(x => {
			if (list.filter(m => m.code == x.code).length == 0)
				list.push({ code: x.code, title: x.name });
		});
		setOptions(list);
	}

	useEffect(() => {
		setOptionList(siteSurvey.model);
	}, [siteSurvey.model])

	useEffect(() => {
		setAllModelOptionList(clist?.filter(x => x.type === 'PRODUCTOPTION'));
		// RayCodeAction.GetAllByFilter({ type: "PRODUCTOPTION" }).then((e) => {
		// 	setAllModelOptionList(e);
		// });

		setSiteSurvey(prev => prev.model ? prev : { ...prev, model: "RAYSCAN α+ (NEW)" });
	}, [clist])

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		setSiteSurvey(prev => ({ ...prev, [name]: value }));
	};

	const Prev = (e) => {
		Update(siteSurvey._id, { ...siteSurvey, siteSurveyStep: 1 });
	};

	const isMg = JSON.parse(localStorage.getItem("user"))?.isMegagen;
	const deviceModelList = isMg ? DeviceModels.filter(x => x.code === 'R2 Studio Q') : DeviceModels;

	const form_controls1 = [
		{
			title: t('installation.title'), items: [
				{ type: "select", name: "model", label: t('product.field.model'), val: siteSurvey.model || "RAYSCAN α+ (NEW)", list: deviceModelList, isEditable: !isSummary },
				{ type: "select2", name: "option", label: t('common.label.option'), val: siteSurvey.option, list: options, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "datetime", name: "scheduleDate", label: t('installation.status.surveyScheduled'), val: siteSurvey.scheduleDate, isEditable: !isSummary },
				{ type: "datetime", name: "trainingDate", label: t('installation.label.surveyTrainingDate'), val: siteSurvey.trainingDate, isEditable: !isSummary }
			]
		},

		{
			title: t('service.label.additionalOrders'), items: [
				{ type: "number", name: "additionalMainUnit", label: t('product.type.mainUnit'), size: 3, val: siteSurvey.additionalMainUnit, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalPortableXray", label: t('product.type.portable'), size: 3, val: siteSurvey.additionalPortableXray, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalThreedPrinter", label: t('product.label.threeDPrinter'), size: 3, val: siteSurvey.additionalThreedPrinter, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalCurningUnit", label: t('product.type.curingUnit'), size: 3, val: siteSurvey.additionalCurningUnit, isEditable: !isSummary, positive: true }
			]
		},
		{
			title: "", items: [
				{ type: "number", name: "additionalRioSensorSize1", label: t('product.label.rioSensorSize1'), size: 3, val: siteSurvey.additionalRioSensorSize1, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalRioSensorSize2", label: t('product.label.rioSensorSize2'), size: 3, val: siteSurvey.additionalRioSensorSize2, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalRioScanStandard", label: t('product.label.rioScanStandard'), size: 3, val: siteSurvey.additionalRioScanStandard, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalRioScanOcctusal", label: t('product.label.rioScanOcclusal'), size: 3, val: siteSurvey.additionalRioScanOcctusal, isEditable: !isSummary, positive: true }
			]
		},
		{
			title: "", items: [
				{
					type: "select", name: "additionalObjectScankit", label: t('scan.type.objectScanKit'), val: siteSurvey.additionalObjectScankit || t('common.label.none'),
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Charged", title: t('common.status.charged') },
						{ code: "Complimentary", title: t('common.status.complimentary') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "additionalRayCeph", label: "RayCeph", val: siteSurvey.additionalRayCeph || t('common.label.none'),
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Charged", title: t('common.status.charged') },
						{ code: "Complimentary", title: t('common.status.complimentary') },
					], isEditable: !isSummary
				}
			]
		},
		{
			title: "", items: [
				{
					type: "select", name: "additionalRayScanweb", label: "RAYSCAN Web", val: siteSurvey.additionalRayScanweb || t('common.label.none'),
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Charged", title: t('common.status.charged') },
						{ code: "Complimentary", title: t('common.status.complimentary') },
					], isEditable: !isSummary
				},
				{ type: "input", name: "additionalRemark", label: t('common.field.remarks'), val: siteSurvey.additionalRemark, isEditable: !isSummary }
			]
		},

		{
			title: t('product.label.resin'), items: [
				{ type: "number", name: "additionalCb500", label: "C&B / 500ml", size: 3, val: siteSurvey.additionalCb500, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalCb1l", label: "C&B / 1L", size: 3, val: siteSurvey.additionalCb1l, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalSg500", label: "SG / 500ml", size: 3, val: siteSurvey.additionalSg500, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalSg1l", label: "SG / 1L", size: 3, val: siteSurvey.additionalSg1l, isEditable: !isSummary, positive: true }
			]
		},
		{
			title: "", items: [
				{ type: "number", name: "additionalDb500", label: "DM / 500ml", size: 3, val: siteSurvey.additionalDb500, isEditable: !isSummary, positive: true },
				{ type: "number", name: "additionalDb1l", label: "DM / 1L", size: 3, val: siteSurvey.additionalDb1l, isEditable: !isSummary, positive: true }
			]
		},

		{
			title: t('installation.label.environment'), items: [
				{ type: "number", name: "environmentUnitChairs", label: t('installation.label.unitChairs'), size: 3, val: siteSurvey.environmentUnitChairs, isEditable: !isSummary, positive: true },
				{ type: "number", name: "environmentClientPc", label: t('product.label.clientPc'), size: 3, val: siteSurvey.environmentClientPc, isEditable: !isSummary, positive: true },
			]
		},
		{
			title: "", items: [
				{ type: "number", name: "environmentWalmountXray", label: t('product.label.wallMount'), size: 3, val: siteSurvey.environmentWalmountXray, isEditable: !isSummary, positive: true },
				{ type: "input", name: "environmentWalmountXrayManufacture", label: t('product.label.wallMount') + ' ' + t('product.field.manufacturer'), val: siteSurvey.environmentWalmountXrayManufacture, isEditable: !isSummary },
				{ type: "number", name: "environmentPotableXray", label: t('product.type.portable'), size: 3, val: siteSurvey.environmentPotableXray, isEditable: !isSummary, positive: true },
				{ type: "input", name: "environmentPotableXrayManufacture", label: t('product.type.portable') + ' ' + t('product.field.manufacturer'), val: siteSurvey.environmentPotableXrayManufacture, isEditable: !isSummary }
			]
		},
	]
	const form_controls2 = [
		{
			title: t('installation.label.shieldRoom'), items: [
				{
					type: "select", name: "shieldroomConstruction", label: t('installation.label.construction'), val: siteSurvey.shieldroomConstruction,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Required", title: t('common.label.required') },
						{ code: "Not required", title: t('common.label.notRequired') },
					], isEditable: !isSummary
				},
				{ type: "input", name: "shieldroomOutputVtg", label: t('installation.field.outputVoltage') + "(V)", val: siteSurvey.shieldroomOutputVtg, isEditable: !isSummary },
				{
					type: "select", name: "shieldroomOutputHz", label: t('installation.field.outputVoltage') + "(Hz)", val: siteSurvey.shieldroomOutputHz || "50Hz",
					list: [
						{ code: "50Hz", title: "50Hz" },
						{ code: "60Hz", title: "60Hz" },
					], isEditable: !isSummary
				}
			]
		},
		{
			title: "", items: [
				{
					type: "select", name: "shieldroomGrounded", label: t('installation.label.grounded'), size: 3, val: siteSurvey.shieldroomGrounded,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					], isEditable: !isSummary
				},
				{ type: "input", name: "shieldroomlGroundVoltage1", label: t('installation.field.l1Ground'), size: 3, val: siteSurvey.shieldroomlGroundVoltage1, isEditable: !isSummary },
				{ type: "input", name: "shieldroomlGroundVoltage2", label: t('installation.field.l2Ground'), size: 3, val: siteSurvey.shieldroomlGroundVoltage2, isEditable: !isSummary },
				{
					type: "select", name: "shieldroomAvrCharged", label: t('product.type.avr'), size: 3, val: siteSurvey.shieldroomAvrCharged,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Required", title: t('common.label.required') },
						{ code: "Not required", title: t('common.label.notRequired') },
					], isEditable: !isSummary
				},
			]
		},
	]
	const form_controls3 = [
		{
			title: t('installation.label.workstation'), items: [
				{
					type: "select", name: "workstationMonitor", label: t('product.type.monitor'), size: 4, val: siteSurvey.workstationMonitor,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Inside room", title: t('installation.label.insideRoom') },
						{ code: "Outside room", title: t('installation.label.outsideRoom') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "workstationLocation", label: t('common.field.location'), size: 4, val: siteSurvey.workstationLocation,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Inside room", title: t('installation.label.insideRoom') },
						{ code: "Outside room", title: t('installation.label.outsideRoom') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "workstationShelf", label: t('installation.label.shelf'), size: 4, val: siteSurvey.workstationShelf,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					], isEditable: !isSummary
				}
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "workstationRemark", label: t('common.field.remarks'), val: siteSurvey.workstationRemark, isEditable: !isSummary }
			]
		},

		{
			title: t('product.label.exposureSwitch'), items: [
				{
					type: "select", name: "exposureswitchLocation", label: t('common.field.location'), size: 4, val: siteSurvey.exposureswitchLocation,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Inside room", title: t('installation.label.insideRoom') },
						{ code: "Outside room", title: t('installation.label.outsideRoom') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "exposureswitchInterlock", label: t('product.label.interlock'), size: 4, val: siteSurvey.exposureswitchInterlock,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Required", title: t('common.label.required') },
						{ code: "Not required", title: t('common.label.notRequired') },
					], isEditable: !isSummary
				},
				{ type: "input", name: "exposureswitchInterlockModel", label: t('product.label.interlock') + ' ' + t('product.field.model'), size: 4, val: siteSurvey.exposureswitchInterlockModel, isEditable: !isSummary }
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "exposureswitchRemark", label: t('common.field.remarks'), val: siteSurvey.exposureswitchRemark, isEditable: !isSummary }
			]
		},

		{
			title: t('product.label.software'), items: [
				{ type: "input", name: "softwareMainProduct", label: t('product.field.mainViewerProduct'), size: 3, val: siteSurvey.softwareMainProduct, isEditable: !isSummary },
				{ type: "input", name: "softwareMainModel", label: t('product.field.mainViewerModel'), size: 3, val: siteSurvey.softwareMainModel, isEditable: !isSummary },
				{ type: "input", name: "softwareThreedProduct", label: t('product.label.threeDViewerProduct'), size: 3, val: siteSurvey.softwareThreedProduct, isEditable: !isSummary },
				{ type: "input", name: "softwareThreedModel", label: t('product.label.threeDViewerModel'), size: 3, val: siteSurvey.softwareThreedModel, isEditable: !isSummary },
				{ type: "input", name: "softwareCephProduct", label: t('product.label.cephTracingProduct'), size: 3, val: siteSurvey.softwareCephProduct, isEditable: !isSummary },
				{ type: "input", name: "softwareCephModel", label: t('product.label.cephTracingModel'), size: 3, val: siteSurvey.softwareCephModel, isEditable: !isSummary },
				{ type: "input", name: "softwareOtherProduct", label: t('product.field.otherProduct'), size: 3, val: siteSurvey.softwareOtherProduct, isEditable: !isSummary },
				{ type: "input", name: "softwareOtherModel", label: t('product.field.otherModel'), size: 3, val: siteSurvey.softwareOtherModel, isEditable: !isSummary },
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "softwareRemark", label: t('common.field.remarks'), val: siteSurvey.softwareRemark, isEditable: !isSummary }
			]
		},

		{
			title: t('product.field.network'), items: [
				{
					type: "select", name: "networkConstruction", label: t('installation.label.construction'), size: 4, val: siteSurvey.networkConstruction,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Required", title: t('common.label.required') },
						{ code: "Not required", title: t('common.label.notRequired') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "networkRouter", label: t('installation.label.router'), size: 4, val: siteSurvey.networkRouter,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "networkRouterType", label: t('installation.field.routerType'), size: 4, val: siteSurvey.networkRouterType,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Wired", title: t('installation.label.wired') },
						{ code: "Wired + Wireless", title: t('installation.label.wiredWireless') },
					], isEditable: !isSummary
				},
				{
					type: "select", name: "networkInternet", label: t('product.field.internet'), size: 4, val: siteSurvey.networkInternet,
					list: [
						{ code: "None", title: t('common.label.none') },
						{ code: "Yes", title: t('common.label.yes') },
						{ code: "No", title: t('common.label.no') },
					], isEditable: !isSummary
				}
			]
		},
		{
			title: "", items: [
				{ type: "input", name: "networkRemark", label: t('common.field.remarks'), val: siteSurvey.networkRemark, isEditable: !isSummary }
			]
		},
	];

	const validNext = async () => {
		let errValidate = [];
		const errValidate1 = RayFormValidation(form_controls1, siteSurvey);
		const errValidate2 = RayFormValidation(form_controls2, siteSurvey);
		const errValidate3 = RayFormValidation(form_controls3, siteSurvey);
		errValidate = errValidate.concat(errValidate1);
		errValidate = errValidate.concat(errValidate2);
		errValidate = errValidate.concat(errValidate3);
		if (errValidate.length > 0) {
			setErrors(errValidate);
			return;
		}
		setIsAddProcess(true);
		try {
			await Update(siteSurvey._id, siteSurvey);
		} catch (error) {
			console.error('SurveyStep1 validNext error:', error);
		} finally {
			setIsAddProcess(false);
		}
	};

	return (
		<>
			<div className={isSummary ? "" : "section mt-2"}>
				<ul className={isSummary ? "nav nav-tabs style3 mb-1" : "nav nav-tabs style2"}>
					<li className="nav-item">
						<a href
							className={category == "info" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("info")}>{t('product.label.productInfo')}</a>
					</li>
					<li className="nav-item">
						<a href
							className={category == "room" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("room")}>{t('installation.label.shieldRoom')}</a>
					</li>
					<li className="nav-item">
						<a href
							className={category == "detail" ? "nav-link active" : "nav-link"}
							onClick={() => setCategory("detail")}>{t('installation.label.installDetails')}</a>
					</li>
				</ul>
			</div>
			{category == "info" &&
				<RayForm controls={form_controls1} showAllFields={true} isSummary={isSummary} isForm={!isSummary} handleChangeData={handleChangeData} errors={errors} />
			}
			{category == "room" &&
				<RayForm controls={form_controls2} showAllFields={true} isSummary={isSummary} isForm={!isSummary} handleChangeData={handleChangeData} errors={errors} />
			}
			{category == "detail" &&
				<RayForm controls={form_controls3} showAllFields={true} isSummary={isSummary} isForm={!isSummary} handleChangeData={handleChangeData} errors={errors} />
			}

			{!isSummary &&
				<div className="section mt-1 mb-2">
					<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
					<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
				</div>
			}
		</>
	);
};

const mapState = (state) => {
	const clist = state.RayCodeReducer.items;
	return { clist };
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(SiteSurveyAction.UpdateSiteSurvey(_id, data)),
});

export default connect(mapState, mapDispatch)(SurveyStep1);